module.exports = __webpack_public_path__ + "images/trusted-by.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader/dist/cjs.js?name=images/[name].[ext]!./src/images/email/trusted-by.png
// module id = ./node_modules/file-loader/dist/cjs.js?name=images/[name].[ext]!./src/images/email/trusted-by.png
// module chunks = 21